import type { IncidentDetailResponse } from '@prerender/diagnostics-api';
import { useId } from 'react';

import { EVIDENCE_TITLE } from './EvidenceTable';
import UrlImpactFigure from './UrlImpactFigure';

type UrlImpactEvidenceProps = {
  incident: IncidentDetailResponse;
};

function UrlImpactEvidence({ incident }: UrlImpactEvidenceProps) {
  const titleId = useId();

  return (
    <section className="diagnostics-detail-section" aria-labelledby={titleId}>
      <h2 id={titleId} className="diagnostics-detail-section-title">
        {EVIDENCE_TITLE}
      </h2>
      <dl className="diagnostics-evidence-figures">
        <UrlImpactFigure
          name="Affected URLs"
          affectedUrlCount={incident.affectedUrlCount}
          crawledUrlCount={incident.crawledUrlCount}
        />
      </dl>
    </section>
  );
}

export default UrlImpactEvidence;
